export default (props, vars) => props?.['name'] === 'linkedin';
